import { Button, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import TableTitle from '../TableTitle'

ButtonTable.propTypes = {
  title: PropTypes.string,
  buttonsDetails: PropTypes.array,
  onClick: PropTypes.func.isRequired,
}
export default function ButtonTable({ title, buttonsDetails, onClick }) {
  return (
    <Grid container alignItems="center">
      <Grid item xs={10} sm={6}>
        <TableTitle text={title} />
      </Grid>
      {buttonsDetails.map((buttonDetail, index) => {
        return (
          <Grid key={`${buttonDetail.name}_${index}`} item xs={1} sm={3}>
            <Button variant="contained" name={buttonDetail.name} color="primary" onClick={onClick}>
              {buttonDetail.title}
            </Button>
          </Grid>
        )
      })}
    </Grid>
  )
}
